module.exports = __webpack_public_path__ + "img/profile-woman-1-min.e9e7fbc6.jpg";